import React from 'react';
import PropTypes from 'prop-types';
import Hue from 'react-color/lib/components/common/Hue';
import CustomPicker from 'react-color/lib/components/common/ColorWrap';
import styles from './styles.scss';

const customPointer = () => {
    return (
        <div
            style={{
                height: '36px',
                width: '12px',
                cursor: 'pointer',
                backgroundColor: '#fff',
                position: 'relative',
                top: '-2px',
                left: '-6px',
                borderRadius: '6px',
                boxShadow: '0 1px 4px rgba(0, 0, 0, 0.37)',
            }}
        />
    );
};

function ReactColorCustom({ color, inputChange, hexValid, onChange, ...rest }) {
    function handleHue(data) {
        onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
    }

    return (
        <div className={styles.root}>
            <div className={styles.hueContainer}>
                <style>{'.hue-horizontal {border-radius: 6px}'}</style>
                <Hue {...rest} direction="horizontal" onChange={handleHue} pointer={customPointer} />
            </div>
            <div className={styles.inputContainer}>
                <input
                    className={!hexValid ? styles.invalidInput : null}
                    style={{ backgroundColor: color, borderColor: color }}
                    type="text"
                    maxLength={6}
                    placeholder="HEX"
                    value={color.substr(1)}
                    onChange={inputChange}
                    name="hexInput"
                />
            </div>
        </div>
    );
}

ReactColorCustom.propTypes = {
    color: PropTypes.string,
    inputChange: PropTypes.func,
    hexValid: PropTypes.bool,
    onChange: PropTypes.func,
};

export default CustomPicker(ReactColorCustom);
